import { Badge, Box } from '@chakra-ui/react';
import { BaseButton } from '@cksoftware/react-base';

type EnterSaleButtonProps = {
  buttonText: string;
  badgeText?: string;
};

export const EnterSaleButton = (props: EnterSaleButtonProps) => {
  const { buttonText, badgeText } = props;
  return (
    <Box position='relative' display='inline-block'>
      {badgeText && (
        <Badge
          position='absolute'
          top={-4}
          right={-12}
          colorPalette='red'
          variant='solid'
          borderRadius='full'
          zIndex={1}
          fontWeight='bold'>
          {badgeText}
        </Badge>
      )}
      <BaseButton width={'200px'} fontSize='md' fontWeight='semibold'>
        {buttonText}
      </BaseButton>
    </Box>
  );
};
